import { UserInfoResponseDto } from "@/data/dto/user/user-info-response-dto";
import { UserInfoEntity } from "@/domain/entity/user/user-info-entity";
import { assertUserInfoResponseDto } from "@/utils/validation/generated/user-info-response-dto.validator";

export class UserInfoMapper {
  static toEntity(dto: UserInfoResponseDto): UserInfoEntity {
    assertUserInfoResponseDto(dto);

    return {
      email: dto.email ?? dto.loginId ?? "",
      name: dto.name ?? dto.fullName ?? "",
      role: dto.role ?? "",
      hospitalName: dto.hospital?.hospitalName ?? "",
      hospitalCode: dto.hospital?.hospitalCode ?? "",
      isExpiredSn: Boolean(dto.isExpiredSn),
    };
  }
}
